module.exports = __webpack_public_path__ + "static/media/suki-logo-navbar-white.5645c6ee.svg";